<template>
  <v-container fluid style="min-width: 450px">
    <v-toolbar>
      <v-toolbar-title>{{ $t('Warehouse') }}</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>

      <v-spacer></v-spacer>

      <template v-for="tab in tabs">
        <v-tooltip bottom :key="tab.value">
          <v-btn slot="activator" flat @click="$router.push(tab.href)" :color="$route.path === tab.href ? 'primary' : 'grey'">
            <v-icon left>{{ tab.icon }}</v-icon>
            {{ tab.text }}
          </v-btn>
          <span>{{ tab.tooltip }}</span>
        </v-tooltip>
      </template>

      <v-spacer></v-spacer>

    </v-toolbar>

    <v-card>
      <v-card-text>
        <router-view></router-view>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'wms',
  data() {
    return {
      tabs: [
        { value: 'Products', text: this.$t('Products'),       icon: 'storage',       href: '/wms/products/store',  tooltip: this.$t('Products')                       },
        { value: 'Import',   text: this.$t('Import'),         icon: 'move_to_inbox', href: '/wms/products/import', tooltip: this.$t('Import from Excell spreadsheet') },
        { value: 'Orders',   text: this.$t('Delivery notes'), icon: 'outbox',        href: '/wms/orders',          tooltip: this.$t('Delivery notes')                 }
      ]
    }
  }
}
</script>
